;(function () {
	'use strict';

  function createIcon(className, colorClass) {
    const icon = document.createElement('span');
    icon.className = `${className} ${colorClass || 'color-text-main'}`;
    icon.setAttribute('aria-hidden', 'true');
    return icon;
  }

  const localizedAnswers = {
    'when will my order ship?':
      '<p>Orders are prepared on business days. Delivery timing is shown at checkout where available, and tracking details are sent after dispatch. Please contact us if you need help with an order.</p>',
    'where do you ship to?':
      '<p>We currently deliver within the United Arab Emirates. Available delivery areas and charges are shown at checkout.</p>',
    'how are the product materials sourced?':
      '<p>Material and safety information is listed on each product page. FRIGG pacifiers are designed and manufactured in Denmark. Please contact us if you need details about a specific product.</p>',
    'what is your return policy?':
      '<p>Please read our <a href="/pages/delivery-returns">Delivery &amp; Returns</a> page for the current return policy.</p>',
    'are all your products really bpa, pvc and phtalate free?':
      '<p>Safety and material details are shown on each product page. Please contact us if you need documentation or information about a specific FRIGG product.</p>',
    'are all your products really bpa, pvc and phthalate free?':
      '<p>Safety and material details are shown on each product page. Please contact us if you need documentation or information about a specific FRIGG product.</p>',
  };

  const hiddenQuestions = new Set([
    'how can i become a frigg retailer?',
  ]);

  function normalizeHeading(heading) {
    return heading.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function localizeFaqItems() {
    document.querySelectorAll('.faq-wrapp .faq-item').forEach(function (item) {
      const heading = item.querySelector('.item-heading');
      const answer = item.querySelector('.item-text');
      if (!heading) return;

      const headingKey = normalizeHeading(heading);

      if (hiddenQuestions.has(headingKey)) {
        item.remove();
        return;
      }

      if (answer && localizedAnswers[headingKey]) {
        answer.innerHTML = localizedAnswers[headingKey];
      }
    });
  }

  function initFaq() {
    localizeFaqItems();

    const legacyItems = document.querySelectorAll(
      '.faq-wrapp .faq-item:not(details)',
    );

    legacyItems.forEach(function (item, index) {
      const heading = item.querySelector('.item-heading');
      const answer = item.querySelector('.item-text');
      if (!heading || !answer) return;

      const details = document.createElement('details');
      details.className = item.className;

      Array.from(item.attributes).forEach(function (attribute) {
        if (attribute.name !== 'class') {
          details.setAttribute(attribute.name, attribute.value);
        }
      });

      const summary = document.createElement('summary');
      summary.className = heading.className;
      summary.innerHTML = heading.innerHTML;

      const colorClass = Array.from(heading.classList).find(function (className) {
        return className.startsWith('color-');
      });

      summary.appendChild(createIcon('icon', colorClass));
      summary.appendChild(createIcon('icon-close', colorClass));

      if (!answer.id) {
        answer.id = `FaqAnswer-${index + 1}`;
      }

      details.appendChild(summary);
      details.appendChild(answer);
      item.replaceWith(details);
    });
  }

  document.addEventListener('DOMContentLoaded', initFaq);
  document.addEventListener('shopify:section:load', initFaq);
})()
